import React, { useEffect } from 'react';
import store from 'store';
import querystring from 'querystring';
import { fetchFileDownload, fetchFileTokenDownload } from './service';

export default function Download(props) {
  const id = props.match.params.id;
  const token = store.get('token_download');
  const expirationDate = store.get('expirationTime');

  if (token && expirationDate) {
    console.log(typeof expirationDate);
    if (Date.now() > expirationDate) {
      store.remove('token_download');
      store.remove('expirationTime');
    }
  }

  useEffect(() => {
    async function downFile(func) {
      const res = await func(id);
      if (res.status !== 200) return;
      window.open(res.result.url, '_blank');
    }
    const query = querystring.parse(props.location.search.slice(1));
    if (query.needAuth === 'false') {
      downFile(fetchFileDownload);
    } else {
      const storage = store.get('token_download') || {};
      if (!storage.access_token) {
        const protocol = window.location.protocol;
        const host = window.location.host;
        const url = `${protocol}//${host}/portal/scan/download/${id}`;
        window.open(url, '_blank');
      } else {
        downFile(fetchFileTokenDownload);
      }
    }
  }, [id, props.history, props.location.search]);
  return <></>;
}
